type TProjectColor = {
  light: string;
  dark: string;
};

type TBoardColor = {
  light: string;
  dark: string;
};

// Basecamp-inspired project colors
export const projectColors: TProjectColor[] = [
  { light: '#DBEAFE', dark: '#1D4ED8' }, // Blue
  { light: '#D1FAE5', dark: '#059669' }, // Green
  { light: '#FEF3C7', dark: '#D97706' }, // Yellow/Orange
  { light: '#FEE2E2', dark: '#DC2626' }, // Red
  { light: '#EDE9FE', dark: '#7C3AED' }, // Purple
  { light: '#FCE7F3', dark: '#DB2777' }, // Pink
  { light: '#CFFAFE', dark: '#0891B2' }, // Cyan
  { light: '#ECFCCB', dark: '#65A30D' }, // Lime
];

export const boardColors: TBoardColor[] = [
  { light: '#F1F5F9', dark: '#64748B' }, // Slate (default)
  { light: '#DBEAFE', dark: '#1D4ED8' }, // Blue
  { light: '#D1FAE5', dark: '#059669' }, // Green
  { light: '#FEF3C7', dark: '#D97706' }, // Yellow/Orange
  { light: '#FEE2E2', dark: '#DC2626' }, // Red
  { light: '#EDE9FE', dark: '#7C3AED' }, // Purple
  { light: '#FCE7F3', dark: '#DB2777' }, // Pink
  { light: '#CFFAFE', dark: '#0891B2' }, // Cyan
];

export const dateFormat = 'MMMM D, YYYY';
export const timeFormat = 'HH:mm A';
export const dateTimeFormat = `${dateFormat} HH:MM`;
